import "./work.css";
import weather2 from "../../assets/weather2.jpg";
import thrift from "../../assets/thrift.png";
import house from "../../assets/house.png";
import infimuse from "../../assets/infimuse.png";
import connectAfric from "../../assets/connectAfric.png";

function Project() {
  return (
    <div className="works__holder">
      <h2 className="title">
        <span>#</span>My Projects
      </h2>
      <div className="work" id="work">
        <div className="work-container bd-grid">
          <div className="work-img">
            <img src={weather2} loading="lazy" />

            <div className="work-link">
              <h2 className="work-heading">Weather app</h2>
              <p>
                Created with <code>React</code>, <code>css</code> and
                <code>API</code>
              </p>
              <a target="blank" href="https://github.com/mike-mbugua/weather">
                Code
              </a>
              <a target="blank" href="https://weather-beige-three.vercel.app/">
                Live Demo
              </a>
            </div>
          </div>

          <div className="work-img">
            <img src={house} loading="lazy" />

            <div className="work-link">
              <h2 className="work-heading">House Management</h2>
              <p>
                Created with <code>React</code>,<code>Ruby On Rails</code> and
                <code>Postgresql</code>
              </p>

              {/* <a target="blank" href="https://coldplaybestband.netlify.app">Live Demo</a> */}
            </div>
          </div>

          <div className="work-img">
            <img src={thrift} loading="lazy" />

            <div className="work-link">
              <h2 className="work-heading">Thrift</h2>
              <p>
                Created with <code>React</code>, <code>Tailwind CSS</code>,
                <code>Postgresql</code> and <code>Ruby on Rails</code>
              </p>
              <a
                target="blank"
                href="https://github.com/mike-mbugua/quinafrontend"
              >
                Code
              </a>
            </div>
          </div>

          <div className="work-img">
            <img src={connectAfric} loading="lazy" />

            <div className="work-link">
              <h2 className="work-heading">Connect Africa</h2>
              <p>
                Created with <code>React</code>, <code>Tailwind CSS</code>,
                <code>Node.js</code>, <code>Express.js</code> and
                <code>MongoDB</code>
              </p>
              <a
                target="blank"
                href="https://github.com/mike-mbugua/ConnectAfrica"
              >
                Code
              </a>
              <a target="blank" href="https://connect-africa-steel.vercel.app">
                Live Demo
              </a>
            </div>
          </div>

          <div className="work-img">
            <img loading="lazy" src={infimuse} />

            <div className="work-link">
              <h2 className="work-heading">Infimuse</h2>
              <p>
                Created with <code>Node.js</code>, <code>MySQL</code>,
                <code>React</code> and <code>Express.js</code>
              </p>
              <a target="blank" href="https://www.infimuse.com">
                Live Demo
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;
